import { render, staticRenderFns } from "./EditAnimals.vue?vue&type=template&id=d4f5073e&"
import script from "./EditAnimals.vue?vue&type=script&lang=js&"
export * from "./EditAnimals.vue?vue&type=script&lang=js&"
import style0 from "./EditAnimals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports